import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDataValue } from './process-data-value';
export { ProcessDataValue };
import { processDataValueSchema } from '@schemas/business-objects/process-data-value';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';

export class ProcessDataValueFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    stringValue: SchemaFormControl;
    numberValue: SchemaFormControl;
    booleanValue: SchemaFormControl;
    sequence: SchemaFormControl;
    dataTypeId: SchemaFormControl;
    dataType: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessDataValue>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processDataValueSchema, ProcessDataValue, data, options);
  }

  get object(): ProcessDataValue {
    return new ProcessDataValue(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'dataType':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessDataValue[]> {
    return ProcessDataValue.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessDataValue | null> {
    return ProcessDataValue.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ProcessDataValue> {
    return ProcessDataValue.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessDataValue>,
  ): Promise<ProcessDataValue> {
    return ProcessDataValue.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessDataValue>,
  ): Promise<ProcessDataValue> {
    return ProcessDataValue.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessDataValue.deleteById(id);
  }
}

export class ProcessDataValueFormArray extends PersistedFormArray {
  declare controls: ProcessDataValueFormGroup[];

  readonly entityName = 'ProcessDataValue' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processDataValueSchema, ProcessDataValue, options);
  }

  protected override createItemGroup() {
    return new ProcessDataValueFormGroup();
  }

  get array(): ProcessDataValue[] {
    return this.controls.map(
      (group: ProcessDataValueFormGroup) => group.object,
    );
  }
}

export class ProcessDataValuePersistedArray extends PersistedArray<ProcessDataValue> {
  readonly entityName = 'ProcessDataValue' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDataValue, options);
  }
}
